import {RendererService} from '../renderer.service';
import {StageService} from '../stage.service';
import {CameraService} from '../camera.service';
import {Injectable} from '@angular/core';

interface ISize {
  width: number;
  height: number;
}

@Injectable()
export class ScreenShotService {

  constructor(
    private stage: StageService,
    private cameraManager: CameraService,
    private rendererService: RendererService
  ) {
  }

  take(size: ISize, cameraPosition): string {
    const oldSize = this.rendererService.get().getSize();
    const camera = this.cameraManager.getCamera();
    const oldCameraPosition = camera.position.clone();

    camera.position.copy(cameraPosition);
    this.rendererService.resize(size.width * 3, size.height * 3);
    this.cameraManager.resize(size.width, size.height);

    camera.scale.set(1, 1, 1);

    this.rendererService.render(this.stage.scene);
    const url = this.rendererService.getScreenShot();

    this.cameraManager.resize(oldSize.width, oldSize.height);
    this.rendererService.resize(oldSize.width, oldSize.height);
    camera.position.copy(oldCameraPosition);

    return url;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/screenShot.service.ts